import { render, staticRenderFns } from "./orderDelete.vue?vue&type=template&id=313cfd52&"
import script from "./orderDelete.vue?vue&type=script&lang=js&"
export * from "./orderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports